import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('machine-list/index', {params});
    },
    getMachine(params) {
        return Service().get('machine-list/get-machine', {params});
    },
    show(id) {
        return Service().get('machine-list/show/'+id);
    },
    create(params) {
        return Service().post('machine-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('machine-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('machine-list/delete/'+id);
    },
    machineDetail(params) {
        return Service().get('machine-list/machine-detail', {params});
    },
}